import React from "react";

export const Globe2 = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1742_14330)">
        <path
          d="M18.3337 10C18.3337 14.6024 14.6027 18.3334 10.0003 18.3334M18.3337 10C18.3337 5.39765 14.6027 1.66669 10.0003 1.66669M18.3337 10H1.66699M10.0003 18.3334C5.39795 18.3334 1.66699 14.6024 1.66699 10M10.0003 18.3334C7.86052 16.0866 6.66699 13.1027 6.66699 10C6.66699 6.8973 7.86052 3.91348 10.0003 1.66669M10.0003 18.3334C12.1401 16.0866 13.3337 13.1027 13.3337 10C13.3337 6.8973 12.1401 3.91348 10.0003 1.66669M1.66699 10C1.66699 5.39765 5.39795 1.66669 10.0003 1.66669"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />

        <path
          d="M18.3337 10C18.3337 14.6024 14.6027 18.3334 10.0003 18.3334M18.3337 10C18.3337 5.39765 14.6027 1.66669 10.0003 1.66669M18.3337 10H1.66699M10.0003 18.3334C5.39795 18.3334 1.66699 14.6024 1.66699 10M10.0003 18.3334C7.86052 16.0866 6.66699 13.1027 6.66699 10C6.66699 6.8973 7.86052 3.91348 10.0003 1.66669M10.0003 18.3334C12.1401 16.0866 13.3337 13.1027 13.3337 10C13.3337 6.8973 12.1401 3.91348 10.0003 1.66669M1.66699 10C1.66699 5.39765 5.39795 1.66669 10.0003 1.66669"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </g>

      <defs>
        <clipPath id="clip0_1742_14330">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
};